
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/[...slug]",
      function () {
        return require("private-next-pages/posts/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/[...slug]"])
      });
    }
  